import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useOsService } from '@/services/OsService/OsService';
import licenseWindows from './OS/license.windows.vue';
import licenseLinux from './OS/license.linux.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'license',
  setup(__props) {

const osService = useOsService();

return (_ctx: any,_cache: any) => {
  return (_unref(osService)?.isWindows.value)
    ? (_openBlock(), _createBlock(licenseWindows, { key: 0 }))
    : (_unref(osService)?.isUnix.value)
      ? (_openBlock(), _createBlock(licenseLinux, { key: 1 }))
      : _createCommentVNode("", true)
}
}

})